import { authHeader } from '../_helpers';
import httpClient from '../utils/http'
import moment from 'moment';
import _ from 'lodash';
import { handleResponseAsync } from '../utils/HelperUtils';

export const employeeService = {
  getAllEmployee
};

function convertViewModelList(data) {
  let viewModel = [];
  if (!_.isEmpty(data) && _.isArray(data)) {
    data.map(o => {
      o.key = o.EmployeeAutoID;
      // delete o._id;
      // delete o.createdAt;
      // delete o.updatedAt;
      viewModel.push(o);
    });
  }
  return viewModel;
}

function getAllEmployee() {
  const url = '/api/employee';

  return httpClient
    .get(url)
    .then(handleResponseAsync)
    .then(res => convertViewModelList(res.data));
}
